import React from "react";

const getIsChecked = (defaultValueFromAnswer, value) => {
  if (!defaultValueFromAnswer) {
    return false;
  }

  return defaultValueFromAnswer === value;
};

const RadioField = ({ name, value, defaultValueFromAnswer, handleChange }) => {
  const isChecked = getIsChecked(defaultValueFromAnswer, value);

  return (
    <input type="radio" name={name} checked={isChecked} value={value} onChange={handleChange} />
  );
};

export default RadioField;
